import axios from "axios";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import { describeImportRequestError } from "./articleImportErrors";

export async function fetchNextArticleImportBarcode() {
  try {
    const response = await axios.get(`${ApiLink.API_URL}ArticleImport/next-barcode`, { headers: authHeader(), timeout: 60000 });
    if (!/^ACC\d{7}$/.test(response.data?.NextBarcode || ""))
      throw new Error("Përgjigjja e serisë ACC nuk përmban barkod të vlefshëm. Kontrolloni backend-in.");
    return response.data.NextBarcode;
  } catch (error) {
    if (!error.isAxiosError) throw error;
    throw new Error(describeImportRequestError(error, "Seria e barkodave ACC"));
  }
}

// Read-only: no article writes or synchronization calls.
export async function fetchArticleImportLookups() {
  const endpoints = ["ArticleGroup/pick", "ArticleGroup/categories/pick", "ArticleUnits/pick",
    "vatrates", "CompanyUnits/getActiveCompanyUnits", "Companies/getCompanyDetails"];
  const labels = ["Grupet", "Kategoritë", "Njësitë matëse", "TVSH-ja", "Njësitë organizative", "Të dhënat e kompanisë"];
  const results = await Promise.all(endpoints.map(async (endpoint, index) => {
    let result;
    try {
      result = await axios.get(`${ApiLink.API_URL}${endpoint}`, { headers: authHeader(), timeout: 60000 });
    } catch (error) {
      throw new Error(describeImportRequestError(error, labels[index]));
    }
    if (!Array.isArray(result.data)) throw new Error(`${labels[index]}: serveri ktheu përgjigje me format të pavlefshëm.`);
    return result;
  }));
  const [groups, categories, units, vatRates, companyUnits, companies] = results.map(result => result.data);
  if (!companies.length || companies[0].VATDeclarant == null)
    throw new Error("Statusi i TVSH-së i kompanisë nuk u verifikua.");
  const declarant = [true, 1, "1", "true"].includes(companies[0].VATDeclarant);
  return {
    groups, categories, units, companyUnits,
    vatRates: vatRates.filter(rate => declarant || Number(rate.VATPercent) === 0),
    // Same two types as the current article form, without importing that form.
    ledgers: [{ LedgerID: 107, LedgerName: "107 Artikull Mall" },
      { LedgerID: 702, LedgerName: "702 Artikull Sherbim" }],
  };
}
